module.exports = __webpack_public_path__ + "static/img/1438_phase_function_Paper_PointsHejduk_Prediction.8b4510f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1438_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZYI1
// module chunks = 0